import { registerDestructor } from '@ember/destroyable';
import Service from '@ember/service';

export default class AlertManagerService extends Service {
  events = ['clearBanner', 'displayBanner', 'displayToast'];

  bindEventHandler({ context, event, handler }) {
    context._boundEventHandler = handler.bind(context);

    this.on(event, context._boundEventHandler);

    registerDestructor(context, () => {
      context.alertManager.off(event);
    });
  }

  broadcast(type, message) {
    if (type === 'toast') {
      this.displayToast(message);
    }

    if (type === 'banner') {
      this.displayBanner(message);
    }
  }

  clear(type) {
    if (type === 'banner') {
      this.clearBanner();
    }
  }

  off(eventName) {
    this[eventName] = null;
  }

  on(eventName, handler) {
    if (this.events.includes(eventName)) {
      this[eventName] = handler;
    } else {
      throw `Undefined event ${eventName}`;
    }
  }
}
